import React from 'react';
import {
  Box,
  Container,
  Flex,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';

type EmptyStateProps = {
  onAddNewGoal?: () => void;
};

export const EmptyState: React.FC<EmptyStateProps> = ({ onAddNewGoal }) => {
  const bgColor = useColorModeValue('white', 'background.dark.lowest');
  const textColor = useColorModeValue('gray.800', 'white');
  const secondaryTextColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box bg={bgColor} color={textColor} w="100%" minH="100vh">
      <Container maxW="100%" px={12} py={8}>
        <Flex
          w="100%"
          minH="calc(100vh - 200px)"
          align="center"
          justify="center"
          direction="column">
          <VStack spacing={4} align="center" textAlign="center">
            <Text
              fontSize="24px"
              fontWeight="bold"
              fontFamily="marketingPage"
              color={textColor}>
              No goals yet
            </Text>
            <Text
              fontSize="16px"
              color={secondaryTextColor}
              fontFamily="marketingPage"
              maxW="500px">
              Create your first goal to track progress and optimize your
              marketing performance.
            </Text>
            <Box mt={4}>
              <Button
                variant="primary"
                buttonName="add-new-goal-empty"
                onClick={onAddNewGoal}>
                Add New Goal
              </Button>
            </Box>
          </VStack>
        </Flex>
      </Container>
    </Box>
  );
};
